import { CalendarClock } from "lucide-react";
import {
  ProblemTimelineParamsSchema,
  defaultProblemTimelineParams,
  type ProblemTimelineParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { WidgetDef } from "../types.js";
import { ProblemTimelineWidget } from "./Component.js";
import { ProblemTimelineExpandedEditor } from "./ExpandedEditor.js";
import { certaintyCounts, certaintySummary } from "./presentation.js";

export const problemTimelineDef: WidgetDef<ProblemTimelineParams> = {
  kind: "problemTimeline",
  label: "Problem Timeline",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 752, h: 384 },
  defaultParams: defaultProblemTimelineParams,
  Component: ProblemTimelineWidget,
  ExpandedComponent: ProblemTimelineExpandedEditor,
  storage: "sql",
  schema: ProblemTimelineParamsSchema,
  accent: "amber",
  icon: CalendarClock,
  subtitle: "Suspect window & exposure",
  defaultRoster: true,
  category: "multi",
  layout: { col: "full", row: 0, width: 752, height: 360 },
  expandable: true,
  renderFooter: (data) => {
    return {
      left: `${data.milestones.length} milestone${data.milestones.length === 1 ? "" : "s"} · Expand to view all`,
      right: certaintySummary(certaintyCounts(data.milestones)),
    };
  },
};

registerWidget(problemTimelineDef);
